import { api } from "../api";

export async function renderPayments(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Payments</h1><div id="x">Загрузка…</div>`;
  const { total, payments } = await api.payments(0, 100);
  el.querySelector("#x")!.innerHTML = `
    <p style="color:#7b8499">${total} платежей</p>
    <div class="table-wrap"><table>
      <thead><tr><th>Когда</th><th>User</th><th>TON</th><th>USD</th>
        <th>Кредиты</th><th>Tx hash</th><th>Memo</th></tr></thead>
      <tbody>${payments.map(p => `
        <tr>
          <td>${(p.at?.$date || p.at || '').toString().slice(0, 19).replace('T', ' ')}</td>
          <td>${p.user_id}</td><td>${p.amount_ton}</td><td>$${(p.usd_at_tx || 0).toFixed(2)}</td>
          <td>+${p.credits_granted}</td>
          <td><code style="font-size:11px">${(p.tx_hash || '').slice(0, 20)}…</code></td>
          <td>${p.memo || ''}</td>
        </tr>`).join("")}
      </tbody>
    </table></div>`;
}
